"use strict";
import React from "react";
import FormsyFields from "./formsyFields";

class Searchbox extends React.Component {
    render() {
        const props = this.props;
        const formProps = { layout: "vertical" };
        return <FormsyFields.Input {...formProps} id={props.id} label={props.title} onChange={props.onChangeEventHandler} name={props.id} type="text" />;
    }
}

module.exports = Searchbox;